import { useState } from 'react';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationSwitchUser } from 'api/mutations/switchUser.mutation';
import { useQueryGetUserDetail } from 'api/queries/getUserDetail.query';

import { useLoginHook } from 'components/App/AuthPublicPages/_hooks/loginHook';
import classes from 'components/Settings/Components/UserProfile/components/userProfile.module.scss';

export const SwitchUser = ({ userEmail }) => {
    const [email, setEmail] = useState<string | undefined>(undefined);
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate } = useMutationSwitchUser();

    const { data: user } = useQueryGetUserDetail({
        email,
    });

    useLoginHook({ user, isSwitchUser: true });

    const switchUser = () => {
        if (userEmail) {
            mutate(
                { userName: userEmail },
                {
                    onSuccess: (response) => {
                        setEmail(response?.email);
                        // handleSnackBar('Status changed successfully', 'success');
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    };

    return (
        <div className={classes.adminActionWrapper}>
            <span className={classes.changePasswordTitle} onClick={switchUser}>
                Login As
            </span>
        </div>
    );
};
